import $ from "jquery";

const scrollAnchor = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        $(document).on("click", '.js-scrollTo[href^="#"]', function (e) {
            e.preventDefault();
            const positionTo = $($(this).attr("href")).position().top;

            window.scrollTo(window.scrollX, positionTo - 100);
        });
    };

    init();
};

try {
    scrollAnchor();
} catch (error) {
    console.error("scrollAnchor", error);
}
